import {
    createContext,
    useContext,
    useEffect,
    useState,
} from "react";


import api from "../utils/axios";
import { logoutUser, } from "../services/authService";


const AuthContext = createContext(null);


export function AuthProvider({ children }) {

    // const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);


    const [user, setUserState] = useState(() => {
        try {
            const storedUser = localStorage.getItem("user");

            return storedUser ? JSON.parse(storedUser) : null;
        } catch (error) {
            console.error("Failed to load user:", error);
            return null;
        }
    });


    const setUser = (updatedUser) => {
        setUserState(updatedUser);

        if (updatedUser) {
            localStorage.setItem(
                "user",
                JSON.stringify(updatedUser)
            );
        } else {
            localStorage.removeItem("user");
        }
    };

    useEffect(() => {

        const token = localStorage.getItem("auth_token");

        //console.log('Token Efftect:', token);

        if (!token) {
            setLoading(false);
            return;
        }


        api
            .get("/auth/me")
            .then((response) => {

                setUser(
                    response.data.user
                );

            })
            .catch(() => {

                localStorage.removeItem(
                    "auth_token"
                );

                localStorage.removeItem(
                    "auth_user"
                );

                setUser(null);

            })
            .finally(() => {
                setLoading(false);
            });

    }, []);


    const login = (user, token) => {

        localStorage.setItem(
            "auth_token",
            token
        );

        localStorage.setItem(
            "auth_user",
            JSON.stringify(user)
        );

        setUser(user);
    };


    const logout = async () => {

        try {
            await logoutUser();
        } catch (error) {
            // Token may already be invalid.
        }

        localStorage.removeItem(
            "auth_token"
        );

        localStorage.removeItem(
            "auth_user"
        );

        setUser(null);
    };


    return (
        <AuthContext.Provider
            value={{
                user,
                setUser,
                loading,
                isAuthenticated: !!user,
                login,
                logout,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}


export function useAuth() {

    return useContext(AuthContext);

}

